import { Claim } from 'common/types/Entities';

import { _request,APIBaseResponse, APIMethod } from '../index';

const TENANTS_PATH_PREFIX = '/tenants';
const USERS_PATH_PREFIX = 'users';
const CLAIMS_PATH_PREFIX = 'claims';

type APIUserClaimsListParams = {
    tenantId: string;
    userId: string;
};

type APIUserClaimsListResponse = APIBaseResponse<Array<UserClaim>>;

export type UserClaim = {
    userId: string;
    tenantId: string;
    userGroupId?: string;
    userGroupName?: string;
    roleId?: string;
    roleName?: string;
    claimValue: string;
    claim: Claim;
};

export const APIUserClaimsGetList: APIMethod<APIUserClaimsListParams, APIUserClaimsListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}/${params.userId}/${CLAIMS_PATH_PREFIX}`)
);
